export default __webpack_public_path__ + "static/media/music-stop-icon.a8ebe021.png";